// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: 'https://devapi.sigeweb.net',
  name: 'development',
  urlBucket: 'https://tga-files-sige.s3.us-east-2.amazonaws.com',

  outsourcingApiEndpoint: 'https://bank-extractor-dev-117761219492.us-central1.run.app',
  sueldosApiEndpoint: 'https://sueldos-403905890000.us-central1.run.app',
  impuestosApiEndpoint: '',
  auditoriaApiEndpoint: ''

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
